import Vue from 'vue'
import Router from 'vue-router'

// Regions
const MainRegion = () => import('@/regions/MainRegion.vue');

// Views
const HomeView = () => import('@/views/Home.vue');
const WallpapersView = () => import('@/views/Wallpapers.vue');
const InGameView = () => import('@/views/InGame.vue');
const StoreView = () => import('@/views/Store.vue');
const FAQView = () => import('@/views/FAQ.vue');
const LoreView = () => import('@/views/Lore.vue');
const AccountView = () => import('@/views/Account.vue');
const SuccessView = () => import('@/views/Success.vue');
const TeamView = () => import('@/views/Team.vue');
const PressKitView = () => import('@/views/PressKit.vue');
const NotFoundView = () => import('@/views/NotFound.vue');
const AffiliateView = () => import('@/views/Affiliate.vue');
const RolesView = () => import('@/views/Roles.vue');
const GatheringView = () => import('@/views/Gathering.vue');
const CraftingView = () => import('@/views/Crafting.vue');
const OrderView = () => import('@/views/Order.vue');
const PerksView = () => import('@/views/Perks.vue');

Vue.use(Router);

let router = new Router({
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  scrollBehavior: function(to) {
      if (to.hash) {
          return {selector: to.hash}
      } else {
          return { x: 0, y: 0 }
      }
  },
  routes: configRoutes()
});

router.beforeEach((to, from, next) => {
  
  Vue.axios.get(router.app.$config.api_url + "/Auth", { withCredentials: true }).then((response) => {
    
    router.app.$config.maint_mode = response.data.game_configs.maintMode;
    router.app.$config.shop_open = response.data.game_configs.shopOpen;
    router.app.$config.youtube_code = response.data.game_configs.youtube;
    router.app.$config.open_play = response.data.game_configs.openPlay;

    if (response.data.user_id && response.data.user_id > 0) {
      router.app.$currentUser = response.data;
    } else {
      router.app.$currentUser = { user_id: 0 }
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (router.app.$currentUser.user_id > 0) {
        next();
      } else {
        window.location = router.app.$config.login_url + '?_xfRedirect=redirect/' + to.meta.returnscript;
      }
    } else {
      if (to.fullPath.substring(0, 2) === '/#') {
        const path = to.fullPath.substring(2);
        next(path);
        return;
      }
      next();
    }

  });
});

export default router

function configRoutes () {
  return [
    {
      path: '/',
      component: MainRegion,
      meta: {
        requiresAuth: false
      },
      children: [
        {
          path: 'newsletter',
          name: 'Newsletter',
          beforeEnter() {
            window.location.replace('https://embersadrift.us9.list-manage.com/subscribe?u=fd822814badc16a8c89fa8de9&id=3ee87d6bc3');
          },
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        },
        {
          path: '',
          name: 'Home',
          component: HomeView,
          meta: {
            requiresAuth: false,
            animateLogo: true
          },
        },
        {
          path: 'wallpapers',
          name: 'Wallpapers',
          component: WallpapersView,
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        },
        {
          path: 'ingame',
          name: 'InGame',
          component: InGameView,
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        },
        {
          path: 'store',
          name: 'Store',
          component: StoreView,
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        },
        {
          path: 'faq',
          name: 'FAQ',
          component: FAQView,
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        },
        {
          path: 'lore',
          name: 'Lore',
          component: LoreView,
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        },
        {
          path: 'account',
          name: 'Account',
          component: AccountView,
          meta: {
            requiresAuth: true,
            returnscript: "Account",
            animateLogo: false
          },
        },
        {
          path: 'success',
          name: 'Success',
          component: SuccessView,
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        },
        {
          path: 'team',
          name: 'Team',
          component: TeamView,
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        },
        {
          path: 'press',
          name: 'Press',
          component: PressKitView,
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        },
        {
          path: 'roles',
          name: 'Roles',
          component: RolesView,
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        },
        {
          path: 'gathering',
          name: 'Gathering',
          component: GatheringView,
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        },
        {
          path: 'crafting',
          name: 'Crafting',
          component: CraftingView,
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        },
        {
          path: 'a/:affiliate',
          name: 'Affiliate',
          component: AffiliateView,
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        },
        {
          path: 'a/:friend/:affiliate',
          name: 'AffiliateFriend',
          component: AffiliateView,
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        },
        {
          path: 'order',
          name: 'Order',
          component: OrderView,
          meta: {
            requiresAuth: true,
            animateLogo: false
          },
        },
        {
          path: 'perks',
          name: 'Perks',
          component: PerksView,
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        },
        {
          path: '*',
          name: 'Not Found',
          component: NotFoundView,
          meta: {
            requiresAuth: false,
            animateLogo: false
          },
        }
      ]
    }
  ]
}